import React from 'react';
import { flowRight } from 'lodash';
import { BUTTON_CREATE_POST } from '../../bi-events/bi-buttons';
import { connect } from '../../components/runtime-context';
import { getQueryLocale } from '../../selectors/locale-selectors';
import { getIsMobile } from '../../store/basic-params/basic-params-selectors';
import { getMetaSiteId } from '../../store/instance-values/instance-values-selectors';

type OwnProps = {
  categorySlug?: string;
  children: React.ReactElement;
};

type Props = OwnProps & ReturnType<typeof mapRuntimeToProps>;

const CreatePostHandler = ({
  categorySlug,
  children,
  buttonClicked,
  navigateWithinPostPage,
}: Props) => {
  const handleClick = () => {
    buttonClicked({ action: BUTTON_CREATE_POST });
    return navigateWithinPostPage(
      `/create-post${categorySlug ? `?categorySlug=${categorySlug}` : ''}`,
    );
  };

  const child = React.Children.only(children);
  return React.cloneElement(child, { onClick: handleClick });
};

import { type Actions, type AppState } from '../../types';

const mapRuntimeToProps = (state: AppState, _ownProps: {}, actions: Actions) => ({
  buttonClicked: actions.buttonClicked,
  navigateWithinPostPage: actions.navigateWithinPostPage,
  metaSiteId: getMetaSiteId(state),
  lang: getQueryLocale(state),
  isMobile: getIsMobile(state),
});

export default flowRight(connect(mapRuntimeToProps))(CreatePostHandler);
